import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DPUser } from './dp-user';
import { DPUserService } from './dp-user.service';
import { DPRole } from './dp-role';
import { DPAccount } from './dp-account';
import { DPAccountService } from './dp-accounts.service';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';

@Component({
    selector: 'my-user-create',
    templateUrl: 'dp-user-create.component.html'
})
export class DPUserCreateComponent implements OnInit {
    @Input() user: DPUser;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    roles: DPRole[];
    selectedRole: DPRole;
    storedRoles: string[];
    storedStatus: number;
    isFirst: any;
    selectedAccount: DPAccount;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    jobTitle = 'Not Identified';
    department = 'Not Identified';
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    constructor(
        private toasterService: ToasterService,

        private _service: NotificationsService,
        private router: Router,
        private userService: DPUserService,
        private accountService: DPAccountService,
        private route: ActivatedRoute) {
    }

    createNotification() {
        this.toasterService.pop(this.notificationType, this.notificationTitle, this.notificationContent);
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }


    getRoles() {
        return this.userService
            .getRoles()
            .then(res => {
                this.roles = res.user_roles;
                this.checkRole(this.roles.find(r => r.role_name == 'Portal Viewer'));
                this.roles = this.roles.filter(r => r.role_name != 'Portal Viewer');
            })
            .catch(error => this.errorHandler(error));
    }

    getAccount(account_id: number) {
        return this.accountService
            .getAccount(account_id)
            .then(res => this.selectedAccount = res)
            .catch(error => this.errorHandler(error));
    }

    ngOnInit() {

        this.route.params.forEach((params: Params) => {
            this.selectedAccount = new DPAccount();
            const account_id = +params['account_id'];
            this.navigated = true;
            this.getAccount(account_id);
        });

        this.user = new DPUser();
        this.getRoles();
        this.storedStatus = 1;
        this.storedRoles = [];

    }
    save1(user: DPUser, isValid: boolean) {
        // call API to save customer
        if (isValid) {
            this.submitting = true;
            user.roles = this.storedRoles;
            user.status = this.storedStatus;
            user.account = this.selectedAccount;
            user.title = this.jobTitle == 'Not Identified' ? undefined : this.jobTitle;
            user.department = this.department == 'Not Identified' ? undefined : this.department;
            user.confirmPassword = undefined;
            user.email_sent = undefined;

            if (user.new_password == undefined || user.new_password == '') {
                const randomstring = Math.random().toString(36).slice(-8) + 'K1a';
                user.new_password = randomstring;
            }
            this.save(user);
        }
    }

    checkRole(role: DPRole) {
        if (this.storedRoles.indexOf(role.role_name, 0) > -1) {
            this.storedRoles.splice(this.storedRoles.indexOf(role.role_name), 1);
        } else {
            this.storedRoles.push(role.role_name);
        }
    }

    checkStatus() {
        if (this.storedStatus == 0) {
            this.storedStatus = 1;
        }
        else {
            this.storedStatus = 0;
        }
    }

    save(user: DPUser) {
        this.user = user;
        this.userService
            .createUser(this.user)
            .then(user => {
                this.user = user; // saved hero, w/ id if new
                this.goBack();
            })
            .catch(error => this.errorHandler(error));
    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account/users', this.selectedAccount.account_id]);

        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-user-create.component.ts